<template>
  <div class="live">
    <div @click="drawPanelCLikc" :class=" drawPanel ? 'livePlayer':'drawPanel' ">
      <!-- 回放视频模块 -->
      <div id="playbackPlayer"></div>
    </div>
    <div @click="drawPanelCLikc" :class=" !drawPanel ? 'livePlayer':'drawPanel' ">
      <!-- 回放文档模块 -->
      <div id="playbackPanel"></div>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        id: '',
        timer: null,
        drawPanel: true // 显示视频模块和显示文档模块
      }
    },
    created () {
      this.id = this.$parent.info.id
      this.timer = setInterval(res => {
        this.htmlTime++
      }, 1000)
      // $.DW.isShowBar(1)
      $.DW.config({
        userId: this.$parent.info.live.userid,
        roomId: this.$parent.info.live.roomid,
        recordId: this.$parent.info.live.record.id,
        groupId: this.$parent.info.live.groupid,
        viewername: this.$parent.info.live.viewername,
        viewertoken: this.$parent.info.live.viewertoken,
        isH5play: true,
        fastMode: true
      })
    },
    methods: {
      drawPanelCLikc () {
        this.drawPanel = !this.drawPanel
      }
    },
    destroyed () {
      this.$http.post('/apipx/Lesson/studyrecord', {
        lesson_id: this.id,
        time_lenght: this.htmlTime,
        num: 0,
        token: JSON.parse(localStorage.getItem('login')).token
      }).then(res => {
        clearInterval(this.timer)
      })
    }
  }
</script>

<style type="text/scss" lang="scss">
  .live {
    width: 100%;
    height: 100%;
    position: relative;

    #playbackPlayer {
      width: 100%;
      height: 100%;
    }

    #playbackPanel {
      width: 100%;
      height: 100%;
    }

    .drawPanel {
      position: absolute;
      left: 20px;
      top: 20px;
      z-index: 100;
      width: 200px;
      height: 200px;
      box-shadow: 0px 0px 20px #c6c6c6;
      border-radius: 5px;
    }

    .livePlayer {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 99;
      width: 100%;
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/videoLayer/playback/playback.vue